module.exports = __webpack_public_path__ + "img/48.49be0e16.png";